import { render, staticRenderFns } from "./goodShow.vue?vue&type=template&id=4719721c&scoped=true&"
import script from "./goodShow.vue?vue&type=script&lang=js&"
export * from "./goodShow.vue?vue&type=script&lang=js&"
import style0 from "./goodShow.vue?vue&type=style&index=0&id=4719721c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4719721c",
  null
  
)

component.options.__file = "goodShow.vue"
export default component.exports